import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import EditTabProperties from '../../../inputs/EditTabProperties';
import AddListItemButton from '../../../inputs/AddListItemButton';
import { addTabProperty, deleteTabProperty } from '../../../actions/apiDealerUpdates';
import { addNewVehicleColumnID } from '../../../actions/apiDepartmentUpdates';

const EditInspection = (props) => {
    const [errors, setErrors] = useState({ addDepartmentPropertyError: false });
    const [optionName, setOptionName] = useState('');
    const dispatch = useDispatch();

    // Use useSelector to get the required state from Redux store
    const vehicleColumns = useSelector(state => state.settings_departments.vehicle_columns);
    const tabProperties = props.tab.tab_properties || []; // Local state for tab properties

    const addNewVehicleColumn = () => {
        const input_name = 'userstamp';
        const name = optionName;
        const errorType = 'add new vehicle column';
        const data = { name, input_name };

        return dispatch(addNewVehicleColumnID(data, errorType)).then((resp) => {
            setOptionName(''); // Reset optionName after adding
            return resp;
        });
    };

    const onChange = (e) => {
        setOptionName(e.target.value);
    };

    const onClick = () => {
        const errorType = 'addTabProperty';
        const vehicleColumn = _.find(vehicleColumns, { name: optionName });

        if (vehicleColumn) {
            const data = {
                vehicle_column_id: vehicleColumn.id,
                tab_id: props.tab.id,
                name: optionName,
            };
            setOptionName(''); // Reset optionName after adding
            dispatch(addTabProperty(data, errorType));
        } else {
            addNewVehicleColumn().then((resp) => {
                const data = {
                    vehicle_column_id: resp,
                    tab_id: props.tab.id,
                    name: optionName,
                };
                setOptionName(''); // Reset optionName after adding
                dispatch(addTabProperty(data, errorType));
            }).catch(ex => console.error(ex));
        }
    };

    const onDelete = (e) => {
        const errorType = 'Delete Tab Property';
        const { id } = e.target.dataset;
        dispatch(deleteTabProperty(id, errorType));
    };

    return (
        <div className="col-md-12">
            <h3 className="text-center">Inspection Form Settings</h3>

            <div className="card space-top-1">
                <div className="card-text">
                    <h3>Defaults</h3>
                    <div className="col-md-12">
                        <textarea className="form-control">"Pass", "Recommend", "Required", "Notes", "Labor Hours", "Parts", "Total", "Completed"</textarea>
                    </div>
                    <div className="col-md-12">
                        <textarea className="form-control">
                            "Rotors", "Suspension", "Axle/Bools/U Joints", "Steering Components",
                            "Shocks/Struts", "Oil Leaks", "Tranny Leaks/Flush", "Exhaust",
                            "Power Steering", "Filters", "Chassis Damage", "Owner's Manual",
                            "Lube Doors/Hinges", "Jack Assembly", "Spare Tire", "Engine Operation", "Cruise", "Alignment", "Steering Wheel Center",
                            "Interior Lights", "Power Accessories", "A/C & Heater", "Seat Belts", "Keys/Fobs"
                        </textarea>
                    </div>

                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>vehicle_column_id</th>
                                <th>order</th>
                                <th>name</th>
                                <th>label</th>
                                <th>required</th>
                                <th>lockable</th>
                                <th>notifications</th>
                                <th>key</th>
                                <th>value</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tabProperties.map(tab_property => (
                                <tr key={`tab_property_${tab_property.id}`}>
                                    <td>{tab_property.vehicle_column_id}</td>
                                    <td>{tab_property.order}</td>
                                    <td>{tab_property.name}</td>
                                    <td>{tab_property.label}</td>
                                    <td>{tab_property.required ? 'Yes' : 'No'}</td>
                                    <td>{tab_property.lockable ? 'Yes' : 'No'}</td>
                                    <td>{tab_property.notifications ? 'Yes' : 'No'}</td>
                                    <td>{tab_property.key}</td>
                                    <td>{tab_property.value}</td>
                                    <td>
                                        <button className={'btn btn-danger btn-sm'} onClick={onDelete} data-id={tab_property.id}>X</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default EditInspection;